// sessionStorage key used as a one-shot guard against infinite reloads when a
// stale-chunk error occurs after a new deploy. Set before reloading; cleared
// after the next successful route render.
export const CHUNK_RELOAD_KEY = '__chunkReloaded';
